import React from "react";

interface IteratorProps<T> {
  data: T[]; // بيانات من نوع جنيريك
  render: (item: T, index: number) => React.ReactNode; // دالة render ترجع عنصر React
}

const Iterator = <T,>({ data, render }: IteratorProps<T>) => {
  return <>{data.map((item, index) => render(item, index))}</>;
};

export default Iterator;
